export default __webpack_public_path__ + "static/media/team-alert.5a3090c5.png";